var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M21.43 10.89 16 21.64a.7.7 0 0 1-1.21 0l-4.22-7.43c-.37-.65.58-1.25 1.1-.7l3.75 3.95 4.82-7.19c.44-.66 1.54-.12 1.18.59"}));
}

Checkmark.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
